import { AppointmentForm } from "@/components/appointment/AppointmentForm";
import { PageHero } from "@/components/shared/PageHero";
import { Phone, ShieldCheck, Clock, MapPin } from "lucide-react";

const REASSURANCE = [
  {
    icon: ShieldCheck,
    title: "Licensed & insured",
    body: "Minnesota license BC645307.",
  },
  {
    icon: Clock,
    title: "Fast turnaround",
    body: "Most inspections booked within a few days.",
  },
  {
    icon: MapPin,
    title: "North metro locals",
    body: "Based in St Francis, serving the Twin Cities north metro.",
  },
];

const Schedule = () => {
  return (
    <main className="bg-background">
      <PageHero
        badge="Free, no-obligation"
        title="Schedule your free inspection"
        subtitle="Pick a day and a time window that suits you. We'll confirm by phone once the route for that day is set — no obligation, no pressure."
      />

      <section className="container mx-auto px-4 py-10 md:py-14">
        <div className="grid lg:grid-cols-[minmax(0,1fr)_320px] gap-10 items-start max-w-5xl mx-auto">
          <AppointmentForm />

          <aside className="space-y-6 lg:sticky lg:top-24">
            <div className="bg-card rounded-2xl p-6 border border-border/50">
              <h2 className="font-heading font-bold text-foreground mb-4">
                Why Cedar Creek
              </h2>
              <ul className="space-y-4">
                {REASSURANCE.map(({ icon: Icon, title, body }) => (
                  <li key={title} className="flex gap-3">
                    <Icon
                      className="w-5 h-5 text-secondary shrink-0 mt-0.5"
                      aria-hidden="true"
                    />
                    <div>
                      <p className="font-semibold text-foreground text-sm">
                        {title}
                      </p>
                      <p className="text-sm text-muted-foreground">{body}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-primary/5 rounded-2xl p-6 border border-border/50 text-center">
              <p className="text-sm text-muted-foreground mb-3">
                Storm damage or an active leak?
              </p>
              <a
                href="tel:+16122989865"
                className="inline-flex items-center gap-2 font-heading font-bold text-lg text-primary hover:underline"
              >
                <Phone className="w-5 h-5" aria-hidden="true" />
                (612) 298-9865
              </a>
              <p className="text-xs text-muted-foreground mt-2">
                Call us directly, we'll prioritize you.
              </p>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
};

export default Schedule;
